module.exports = __webpack_public_path__ + "./images/5f7467fa5ced8cd70e2cfc3aa42bfcfe.webp";